// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"6de7291c639bd955","4184":"18d5feeb0397dbae"}[chunkId] + ".css";
};